import { useState } from "react";

export type WizardStep =
  | "UPLOAD"
  | "VALIDATE_ERRORS"
  | "REVIEW"
  | "SEND_INVITATIONS"
  | "DONE";

export interface UseBulkImportWizardReturn {
  step: WizardStep;
  requestId: string | null;
  validationErrors: Array<{
    sheet: string;
    row?: number | null;
    column?: string | null;
    message: string;
  }>;
  setStep: (step: WizardStep) => void;
  setRequestId: (id: string) => void;
  setValidationErrors: (
    errors: Array<{
      sheet: string;
      row?: number | null;
      column?: string | null;
      message: string;
    }>
  ) => void;
  reset: () => void;
}

export function useBulkImportWizard(
  initialRequestId?: string | null
): UseBulkImportWizardReturn {
  const [step, setStep] = useState<WizardStep>(
    initialRequestId ? "REVIEW" : "UPLOAD"
  );
  const [requestId, setRequestId] = useState<string | null>(
    initialRequestId ?? null
  );
  const [validationErrors, setValidationErrors] = useState<
    Array<{
      sheet: string;
      row?: number | null;
      column?: string | null;
      message: string;
    }>
  >([]);

  function reset() {
    setStep("UPLOAD");
    setRequestId(null);
    setValidationErrors([]);
  }

  return {
    step,
    requestId,
    validationErrors,
    setStep,
    setRequestId,
    setValidationErrors,
    reset,
  };
}
